/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { brandingDataRequestGenerationErrorSchema } from './BrandingDataRequestGenerationErrorSchema'

export const brandingDataRequestSchema = z.object({
	id: z.string().nullable().optional(),
	organisationId: z.string().nullable().optional(),
	name: z.string().nullable().optional(),
	website: z.string().nullable().optional(),
	logoId: z.string().nullable().optional(),
	logo: z.object({
		id: z.string(),
		name: z.string(),
		fileName: z.string(),
		category: z.union([z.literal('image'), z.literal('file')]),
		mimeType: z.string().nullable().optional(),
		size: z.number(),
		humanReadableSize: z.string(),
		imgix_url: z.string(),
		collectionName: z.union([
			z.literal('ad-asset'),
			z.literal('baked-story'),
			z.literal('baked-feed'),
			z.literal('story'),
			z.literal('feed'),
			z.literal('landing-page'),
			z.literal('logo'),
			z.literal('generated'),
			z.literal('uploaded'),
			z.literal('imported'),
			z.literal('candidate-files'),
			z.literal('custom-font'),
			z.literal('design'),
			z.literal('whatsapp-profile'),
		]),
		width: z.number(),
		height: z.number(),
		isPlaceholder: z.boolean(),
		isGenerating: z.boolean(),
		createdAt: z.iso.datetime(),
		isGenerated: z.boolean().optional().default(false),
		startedGenerationAt: z.iso.datetime().nullable().optional(),
		finishedGenerationAt: z.iso.datetime().nullable().optional(),
		meta: z.record(z.string(), z.unknown()).nullable().optional(),
	}).nullable().optional(),
	toneOfVoice: z.string().nullable().optional(),
	visualGuidance: z.string().nullable().optional(),
	cornerRadius: z.string().nullable().optional(),
	background: z.string(),
	foreground: z.string(),
	accentBackground: z.string(),
	accentForeground: z.string(),
	fonts: z.object({ title: z.string().nullable(), body: z.string().nullable() }).optional(),
	createdAt: z.iso.datetime().nullable().optional(),
	updatedAt: z.iso.datetime().nullable().optional(),
	isGenerated: z.boolean().optional().default(false),
	startedGenerationAt: z.iso.datetime().nullable().optional(),
	finishedGenerationAt: z.iso.datetime().nullable().optional(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
	generateKeyImage: z.boolean().optional().default(true),
	generationError: brandingDataRequestGenerationErrorSchema.nullable().optional(),
})

export type BrandingDataRequestSchema = z.infer<typeof brandingDataRequestSchema>
